

function initMainSlider() {
  $('.wd-main-slider').slick({
    infinite: false,
    slidesToShow: 1,
    fade: true,
    slidesToScroll: 1,
    arrows: true,
    asNavFor : '.wd-thumbnail-slider',
    prevArrow: '<button class="slick-prev slick-arrow wd-prev-arrow" aria-label="Previous" type="button">Previous</button>',
    nextArrow: '<button class="slick-next slick-arrow wd-next-arrow" aria-label="Next" type="button">Next</button>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          adaptiveHeight: true,
          infinite: false,
        }
      },
      {
        breakpoint: 768,
        settings: {
          adaptiveHeight: true,
          infinite: false,
        }
      }
    ]
  });
}

function initThumbnailSlider() {
  $('.wd-thumbnail-slider').slick({
    infinite: false,
    centerMode: false,
    centerPadding: '0px',
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    vertical: true,
    focusOnSelect: true,
    asNavFor : '.wd-main-slider',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          vertical: false
        }
      },
      {
        breakpoint: 768,
        settings: {
          vertical: false,
        }
      }
    ]
  });
}

function initSlideshowSlider() {
  $('.wd-slideshow-slider').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1
  });
}

$(document).ready(function(){
  initMainSlider();
  initThumbnailSlider();
  initSlideshowSlider();
});
